export default "__VITE_ASSET__jl2UAJMv__"